module.exports = __webpack_public_path__ + "static/img/15.b297ae5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/15.png
// module id = aNr9
// module chunks = 0